export default value => (value ? 'Yes' : 'No');
